import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dreamkeeper_avatar'

export default function DreamkeeperAvatarPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Choose your dreamkeeper avatar',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamkeeperAvatar.heading')}
      buttons={[
        {
          text: `🦉 ${t('pages.onboarding.dreamkeeperAvatar.options.wiseOwl')}`,
          value: 'A wise owl',
        },
        {
          text: `☁️ ${t('pages.onboarding.dreamkeeperAvatar.options.playfulCloudSpirit')}`,
          value: 'A playful cloud spirit',
        },
        {
          text: `🐙 ${t('pages.onboarding.dreamkeeperAvatar.options.glowingJellyfish')}`,
          value: 'A glowing jellyfish',
        },
        {
          text: `🐈‍⬛ ${t('pages.onboarding.dreamkeeperAvatar.options.cosmicCat')}`,
          value: 'A cosmic cat',
        },
        {
          text: `🌠 ${t('pages.onboarding.dreamkeeperAvatar.options.letStarsPick')}`,
          value: 'Let the stars pick for me',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
